<script setup>
import { defineModel } from "vue";
const model = defineModel(); 
</script>

<template>
  <div class="search-wrapper">
    <input
      v-model="model"
      type="text"
      placeholder="Поиск"
    >
    <i class="icon-search" />
  </div>
</template>

<style scoped lang="scss">

input {
  all: unset;
}

.search-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 8px;
  background: #ffffff;
  gap: 10px;

  input {
    width: 95%;

  }

  img {
    width: 14px;
    height: 14px;
  }
}

</style>